import type { DynamicDialogData } from '@bizzdesign/modeler/models';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import type { DynamicDialogConfig } from 'primeng/dynamicdialog';

export const dialogShortcutsUiEvents = eventGroup({
  source: 'Dialog Shortcuts UI',
  events: {
    dialogClosed: type<void>(),
    dialogOpened: type<DynamicDialogConfig<DynamicDialogData>>(),
  },
});
